import * as navigation from 'Navigation';

export default class ProcessTaskDetailsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Task Details',
      closeable: false,
      preferenceKey: 'process-task-details',
    };
  }
}
